import { render } from "./TopTemplate.vue?vue&type=template&id=42fca944&scoped=true&ts=true"
import script from "./TopTemplate.vue?vue&type=script&lang=ts"
export * from "./TopTemplate.vue?vue&type=script&lang=ts"

import "./TopTemplate.vue?vue&type=style&index=0&id=42fca944&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fca944"]])

export default __exports__